import logo from '../../assets/Logo.png';

export function BackgroundLeftText() {
  return (
    <div className="flex flex-col w-1/2 justify-center items-center gap-[104px] flex-shrink-0">
      <div className="text-[40px] flex flex-col gap-6 ">
        <p className="text-left text-white leading-[48px] font-reddit font-light">
          Your <span className="font-extrabold">Trusted</span> Path
          <br /> <span className="font-light">to AI Compliance.</span>
        </p>
        <p className="text-left text-white text-base font-normal font-reddit">
          Compliance in weeks — not months. <br />
          At 70% less cost.
        </p>
      </div>
      <img src={logo} alt="Logo" className="w-[358px] h-[80px] pl-4" />
    </div>
  );
}
